import React from 'react';
import { GallerySection } from '../components/GallerySection';
export const GalleryPage = () => {
  return <div className="bg-white w-full" data-id="element-773">
      <GallerySection data-id="element-774" />
    </div>;
};